

import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import customStyles from "../../../../../assets/styles/customStyles";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { Image } from "antd";
import { Checkbox } from "@mui/material";
import { getColumnWidth, capitalizeFirstLetter } from "../../../../../helpers/utilities";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";

export const MyproductList = (props) => {
    const { details, loadMore, selected, handleClick, duplicates, onSelected, onView, heads, checkbox, sortOrder, sortBy, onRequestSort } = props;
    const isSelected = (name) => selected && selected.indexOf(name) !== -1;
    const classes = customStyles();

    return (
        <CustomInfiniteScroll
            loadMore={true}
            loadMoreContent={false}
            heads={heads}
            width={true}
            selected={selected}
            sortOrder={sortOrder}
            sortBy={sortBy}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            details={details}
            onSelected={(value) => onSelected(value)}
            customClasses={clsx(classes.tableRoot, classes.tableRootProduct)}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={10}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details.length > 0 ? details.map((data, i) => (
                                        <TableRow
                                            key={i}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            {
                                                checkbox && <TableCell className={clsx('checkbox', classes.tablealign)} onClick={(e) => handleClick(data.id)}
                                                    padding="checkbox"><Checkbox checked={isSelected(data.id)} /></TableCell>
                                            }
                                            <TableCell style={{ width: getColumnWidth(heads, 0) }}>
                                                <NavLink style={{ width: getColumnWidth(heads, 0) }} to={`#`} onClick={() => onView(data)}
                                                    className={clsx(classes.color, classes.wordBreak,
                                                        classes.positionRelative, classes.disBlock, classes.bold,
                                                        { [classes.colorRed]: duplicates.length > 0 && duplicates.includes(data.id) })}>{data?.productName} </NavLink>
                                            </TableCell>
                                            <TableCell style={{ width: getColumnWidth(heads, 1) }}><span style={{ width: getColumnWidth(heads, 1) }}>{data?.productId}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(heads, 2) }}><span style={{ width: getColumnWidth(heads, 2) }}>{data?.category?.categoryName || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(heads, 3) }}><span style={{ width: getColumnWidth(heads, 3) }}>{capitalizeFirstLetter(data?.type)}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(heads, 4) }}><span style={{ width: getColumnWidth(heads, 4) }}>{data.skuQuantity}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(heads, 5) }}><span style={{ width: getColumnWidth(heads, 5) }}>{data?.skuUnit?.name || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(heads, 6) }}><span style={{ width: getColumnWidth(heads, 6) }}>{data?.salesUnit?.name || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(heads, 7) }}><span style={{ width: getColumnWidth(heads, 7) }}>{data?.hsn?.hsnCode || '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(heads, 8) }}><span style={{ width: getColumnWidth(heads, 8) }}>{data?.productGst?.code || '---'}</span></TableCell>
                                            {
                                                !checkbox &&
                                                <TableCell>
                                                    <NavLink to={"#"} onClick={() => handleClick(data.id)}>
                                                        <Image
                                                            src={DeleteIcon}
                                                            preview={false}
                                                        />
                                                    </NavLink>
                                                </TableCell>
                                            }

                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={10}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}>For the Chosen Catalogue There are No Products Available. Please Contact Younote Admin for adding the Products</p>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}